import { MatchRepository } from '../../domain/repositories';
import { Match } from '../../domain/models';
import { MatchDataSource } from '../datasources';
import { matchEntityToModel, matchModelToEntity } from '../entities';

export class MatchRepositoryImpl implements MatchRepository {
  constructor(private dataSource: MatchDataSource) {}

  async create(match: Omit<Match, 'id' | 'createdAt' | 'updatedAt'>): Promise<Match> {
    const entity = matchModelToEntity(match);
    const createdEntity = await this.dataSource.create(entity as any);
    return matchEntityToModel(createdEntity);
  }

  async getById(id: string): Promise<Match | null> {
    const entity = await this.dataSource.getById(id);
    if (!entity) return null;
    return matchEntityToModel(entity);
  }

  async getByTournamentId(tournamentId: string): Promise<Match[]> {
    const entities = await this.dataSource.getByTournamentId(tournamentId);
    return entities.map(matchEntityToModel);
  }

  async update(id: string, match: Partial<Match>): Promise<Match> {
    const entity = matchModelToEntity(match);
    const updatedEntity = await this.dataSource.update(id, entity);
    return matchEntityToModel(updatedEntity);
  }

  async delete(id: string): Promise<void> {
    await this.dataSource.delete(id);
  }
}
